import { useQuery } from "@tanstack/react-query";
import { backendApi } from "./api.service";
import { WalletCheckResponse, WalletUserListResponse } from "@/types";

const config = { withCredentials: true };

export const useGetWalletCheck = () => {
  return useQuery({
    queryKey: ["wallet-check"],
    queryFn: async () => {
      const response = await backendApi.get<WalletCheckResponse>(
        "/admin/wallets/check",
        config
      );
      return response.data;
    },
  });
};

export const useGetWalletUserList = () => {
  return useQuery({
    queryKey: ["wallet-user-list"],
    queryFn: async () => {
      const response = await backendApi.get<WalletUserListResponse>(
        "/admin/wallets/user-list",
        config
      );
      return response.data;
    },
  });
};